/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsPostClientCredentialsIntegrationAccountsRequestBody
 */
export interface JumboStructsPostClientCredentialsIntegrationAccountsRequestBody {
    /**
     * 
     * @type {string}
     * @memberof JumboStructsPostClientCredentialsIntegrationAccountsRequestBody
     */
    clientID: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsPostClientCredentialsIntegrationAccountsRequestBody
     */
    clientSecret: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsPostClientCredentialsIntegrationAccountsRequestBody
     */
    url: string;
}

/**
 * Check if a given object implements the JumboStructsPostClientCredentialsIntegrationAccountsRequestBody interface.
 */
export function instanceOfJumboStructsPostClientCredentialsIntegrationAccountsRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "clientID" in value;
    isInstance = isInstance && "clientSecret" in value;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function JumboStructsPostClientCredentialsIntegrationAccountsRequestBodyFromJSON(json: any): JumboStructsPostClientCredentialsIntegrationAccountsRequestBody {
    return JumboStructsPostClientCredentialsIntegrationAccountsRequestBodyFromJSONTyped(json, false);
}

export function JumboStructsPostClientCredentialsIntegrationAccountsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsPostClientCredentialsIntegrationAccountsRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'clientID': json['clientID'],
        'clientSecret': json['clientSecret'],
        'url': json['url'],
    };
}

export function JumboStructsPostClientCredentialsIntegrationAccountsRequestBodyToJSON(value?: JumboStructsPostClientCredentialsIntegrationAccountsRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'clientID': value.clientID,
        'clientSecret': value.clientSecret,
        'url': value.url,
    };
}

